import "./modules/common";
import VueApp from "~/Scripts/new/vueApp";
import GoogleMapVue from "~/Components/Common/GoogleMapVue.vue";
import ContactForm from "~/Components/Contact/ContactForm.vue";
import { navigation, validation } from "~/Scripts/mixins/common";

new VueApp( {
  name: "ContactUs",
  mixins: [navigation, validation],
  components: {
    GoogleMapVue,
    ContactForm,
  },
} );
